<div class="po-wrapper">

  <!-- [*MainMenu] -->

    <po-menu #mainMenu
      p-short-logo="./assets/image/logo-solida.png"
      p-logo="./assets/image/logo-solida.png"
      [p-collapsed]="false"
      [p-filter]="true"
      [p-menus]="menusFiltrados">
    </po-menu>

  <po-toolbar
    p-actions-icon="po-icon-company"
    [p-profile]="profile"
    [p-profile-actions]="profileActions"
    [p-actions]="actions"
    [p-title]="title">
  </po-toolbar>

  <!-- [*Router] -->
  <router-outlet></router-outlet>

</div>

<po-modal p-title="Empresas" [p-primary-action]="close" >
  <po-table class="po-sm-12 po-md-12 po-lg-12"
    p-container
    [p-height]="400"
    [p-hide-select-all]="true"
    [p-selectable]="true"
    (p-selected)="empresaSelecionada($event)"
    [p-show-more-disabled]="true"
    [p-single-select]="true"
    [p-striped]="true"
    [p-items]="itens"
    [p-columns]="empresaColumns"
    p-spacing="small"
  ></po-table>
</po-modal>
